import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openFieldDetailsLabel: {
		id: 'polaris-ideas.right-sidebar.global-fields.global-field-list.global-fields-selector.global-field-item.open-field-details-label',
		defaultMessage: 'Open field details',
		description: 'Label for the chevron button that opens field details',
	},
});
